<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Editar Avaliação Nacional
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-text-field
            v-model="title"
            hint="Será exibido no portal"
            :error-messages="formErrors.title"
            label="Titulo da avaliação"
            @input="formErrors.title = ''"
          />
          <v-text-field
            v-model="subtitle"
            hint="Será exibido no portal"
            :error-messages="formErrors.subtitle"
            label="Subtitulo da avaliação (opcional)"
            @input="formErrors.subtitle = ''"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onSubmit"
          >
            Salvar
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import handlesServerValidation from '@/mixins/handles-server-validation.js'
export default {
  components: {
  },

  mixins: [
    handlesServerValidation
  ],
  props: {
    exam: { type: Object, default: undefined }
  },
  data: () => ({
    title: '',
    subtitle: ''
  }),
  computed: {
  },
  created () {
    if (this.exam) {
      this.title = this.exam.title
      this.subtitle = this.exam.subtitle
    }
  },

  methods: {
    onCancel () {
      this.$emit('resolve', false)
    },

    async onSubmit () {
      const data = {
        title: this.title,
        subtitle: this.subtitle
      }
      try {
        await this.$api.updateExams(this.exam.id, data)
        this.$store.dispatch('setSnackBar', { text: 'Avaliação atualizado com sucesso!', color: 'green' })
        this.$emit('resolve', true)
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível atualizar a avaliação, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
